import { render, staticRenderFns } from "./TranslationsGroupTablePage.vue?vue&type=template&id=250625fc&scoped=true"
import script from "./TranslationsGroupTablePage.vue?vue&type=script&lang=js"
export * from "./TranslationsGroupTablePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250625fc",
  null
  
)

export default component.exports